module.exports = __webpack_public_path__ + "img/testimonial-rhiannon.5466a62d.png";